export const privacyLoading =  ({store})  => store.privacyReducer.loading;

export const privacyError =  ({store})  => store.privacyReducer.error;

export const privacyData =  ({store})  => store.privacyReducer.data;